export default __webpack_public_path__ + "static/media/stock-flat.72cffe9b.svg";